import { LAYER_TYPES, LAYER_SUBTYPES } from '../../../../api/Layers/Layers';

const tmsServerURL = `https://geoserver.ipsilum.com/geoserver/gwc/service/tms/1.0.0/`;
const wmsServerURL = `https://geoserver.ipsilum.com/geoserver/wms`;

export default [
  {
    name: 'Canarias Raster TMS 2',
    url: `${tmsServerURL}Canarias:orto_zona2@EPSG:900913@png/{z}/{x}/{-y}.png`,
    attribution: 'Generic attribution',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TMS,
    description: 'Raster Layer Example via Tile Map Service ',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    },
    styleId: 'TMS STYLE'
  },
  {
    name: 'Canarias Vector Layer TMS 2',
    url: `${tmsServerURL}Vector@EPSG:900913@png/{z}/{x}/{y}.png`,
    attribution: 'Generic attribution',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TMS,
    description: 'Vector Layers Example generated with Ortosky',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    },
    styleId: 'TMS STYLE'
  },
  {
    name: 'Canarias Vector Layer WMS 2',
    url: wmsServerURL,
    attribution: 'Generic attribution',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.WMS,
    layerNames:
      'Canarias:BCN0101L_LIM_ADM_CART,Canarias:BCN0107S_ZON_PRO,Canarias:BCN0204P_PUN_ACO,Canarias:BCN0207L_DISCON_L,Canarias:BCN0207S_DISCON_S,Canarias:BCN0221L_CURV_NIV,Canarias:BCN0305L_CAU_ART,Canarias:BCN0308L_TUB_SERV,Canarias:BCN0328S_ALM_AGU,Canarias:BCN0331S_DEP_AGU,Canarias:BCN0404P_ARBOL,Canarias:BCN0502S_ENT_POB,Canarias:BCN0507S_EDIFIC,Canarias:BCN0513S_INS_IND,Canarias:BCN0528L_CERRAM,Canarias:BCN0531L_LIN_MAN,Canarias:BCN0543L_TUNEL_L,Canarias:BCN0555L_CON_HIS_L,Canarias:BCN0567P_INS_REC_P,Canarias:BCN0605L_CARRETERA,Canarias:BCN0622L_URBANA,Canarias:BCN0623L_CAMINO,Canarias:BCN0626L_SENDA,Canarias:BCN0632L_ITINER,Canarias:BCN0635L_VIA_PEC,Canarias:BCN0725P_ANTENA',
    layerTitles:
      'BCN0101L_LIM_ADM_CART,BCN0107S_ZON_PRO,BCN0204P_PUN_ACO,BCN0207L_DISCON_L,BCN0207S_DISCON_S,BCN0221L_CURV_NIV,BCN0305L_CAU_ART,BCN0308L_TUB_SERV,BCN0328S_ALM_AGU,BCN0331S_DEP_AGU,BCN0404P_ARBOL,BCN0502S_ENT_POB,BCN0507S_EDIFIC,BCN0513S_INS_IND,BCN0528L_CERRAM,BCN0531L_LIN_MAN,BCN0543L_TUNEL_L,BCN0555L_CON_HIS_L,BCN0567P_INS_REC_P,BCN0605L_CARRETERA,BCN0622L_URBANA,BCN0623L_CAMINO,BCN0626L_SENDA,BCN0632L_ITINER,BCN0635L_VIA_PEC,BCN0725P_ANTENA',
    description: 'Vector Layers Example generated with Ortosky',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/58__.png',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-16.395033076987602, 28.29202498646525]
      },
      properties: {
        zoom: 14
      }
    },
    styleId: 'WMS STYLE',
    wmsVersion: '1.3.0'
  },
  {
    name: 'Madrid Raster TMS 2',
    url: `${tmsServerURL}Madrid:MTN25@EPSG:900913@png/{z}/{x}/{-y}.png`,
    attribution: 'Generic attribution',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TMS,
    description: 'Raster Layer Example via Tile Map Service ',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/03__.png',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.599354554899037, 40.372922686649474]
      },
      properties: {
        zoom: 12
      }
    },
    styleId: 'TMS STYLE'
  },
  {
    name: 'Madrid Vector Layer TMS 2',
    url: `${tmsServerURL}VectorMadrid@EPSG:900913@png/{z}/{x}/{-y}.png`,
    attribution: 'Generic attribution',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TMS,
    description: 'Vector Layers Example generated with Ortosky (BTN - 25)',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.599354554899037, 40.372922686649474]
      },
      properties: {
        zoom: 12
      }
    },
    styleId: 'TMS STYLE'
  }
];
